// Kích thước khung layout — MỘT nguồn chuẩn duy nhất.
//
// Vì sao cần: trước đây mỗi trang/bảng tự hardcode `calc(100vh - Npx)` với N
// khác nhau (24 bảng dùng 24 con số từ 209 đến 300). Không con số nào đúng được
// lâu vì nó phụ thuộc chiều cao THỰC của hàng filter — hàng này đổi theo role,
// theo nội dung, và cứ thêm 1 hàng mới (vd DeadlineFilterBar) là lệch tiếp.
// Hậu quả: phần paging dưới bảng bị footer `position: fixed` che, phải zoom
// 80% mới thấy.
//
// Cách dùng đúng: trang đặt chiều cao = CONTENT_HEIGHT rồi cho vùng bảng
// `flex: 1; minHeight: 0` để tự chiếm phần còn lại — KHÔNG cộng trừ px nữa.

// Header: Box marginTop 56 trong components/AppLayout/AppLayout.js.
export const HEADER_HEIGHT = 56;

// Footer: #app-footer là position: fixed, CAO KHÁC NHAU theo bề rộng màn hình
// (xem containers/AppLayout/AppFooter/AppFooter.css):
//   > 960px : 30px
//   ≤ 960px : 60px  ← media query, footer xuống 2 dòng
//
// LỖI đã sửa 2026-09-11: AppLayout luôn bù marginBottom = 30 bất kể bề rộng,
// nên ở cửa sổ ≤960px footer đè lên 30px cuối của vùng nội dung — đúng chỗ
// thanh phân trang. Hai hằng số dưới đây phải khớp với file CSS đó.
export const FOOTER_HEIGHT = 30;
export const FOOTER_HEIGHT_SM = 60;
export const FOOTER_BREAKPOINT = 960;

// Chiều cao còn lại cho nội dung trang, theo chiều cao footer thực tế.
// Dùng qua hook useContentHeight() để tự đổi theo bề rộng màn hình.
export const contentHeightFor = (footerHeight) =>
  `calc(100vh - ${HEADER_HEIGHT + footerHeight}px)`;

// Giữ lại cho code chỉ cần giá trị mặc định (màn rộng).
export const CONTENT_HEIGHT = contentHeightFor(FOOTER_HEIGHT);
